// src/pages/ShippingInfoPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ShippingInfoPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const SectionTitle = ({ children }) => (
    <h2 className="text-xl font-black text-[#0F2F63] mt-8 mb-4 border-b border-gray-100 pb-2">
      {children}
    </h2>
  );

  const BulletPoint = ({ children }) => (
    <li className="flex items-start mb-2.5">
      <span className="text-[#FF7A59] mr-3 mt-1.5"><i className="fas fa-circle text-[6px]"></i></span>
      <span className="text-gray-600 font-medium leading-relaxed flex-1">{children}</span>
    </li>
  );

  return (
    <div className="py-6 px-4 md:px-8 max-w-4xl mx-auto w-full min-h-[70vh] animate-fade-in">
      <div className="flex items-center gap-4 mb-6 border-b border-gray-100 pb-5">
        <button 
          onClick={() => navigate(-1)} 
          className="w-10 h-10 rounded-full bg-white shadow-sm border border-gray-200 hover:bg-gray-50 flex items-center justify-center text-gray-600 transition-colors"
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <h1 className="text-2xl md:text-3xl font-black text-[#0F2F63] flex items-center gap-3">
          <i className="fas fa-truck-fast text-[#FF7A59]"></i> Shipping Information
        </h1>
      </div>

      <div className="bg-white p-6 md:p-10 rounded-3xl shadow-sm border border-gray-100">
        <SectionTitle>1. Delivery Modes</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          SV MART offers two primary modes of delivery to suit your convenience:
        </p>
        <ul className="mb-4">
          <BulletPoint><strong className="text-gray-800">Quick Delivery:</strong> Instant delivery for your immediate grocery and daily needs. We aim to deliver these orders within minutes to a few hours depending on your exact location.</BulletPoint>
          <BulletPoint><strong className="text-gray-800">Standard Delivery:</strong> Scheduled deliveries for bulk orders, heavy items, and non-urgent supplies, typically delivered within the same day or the next day.</BulletPoint>
        </ul>

        <SectionTitle>2. Delivery Fees</SectionTitle>
        <ul className="mb-4">
          <BulletPoint>Delivery charges are calculated based on your location and the selected delivery mode.</BulletPoint>
          <BulletPoint>We frequently offer <strong className="text-[#2CCE75]">Free Delivery</strong> on orders exceeding a specific cart value. This threshold will be clearly displayed in your cart before checkout.</BulletPoint>
          <BulletPoint>During peak hours, bad weather, or high demand, a small surge fee might apply to ensure availability of delivery partners.</BulletPoint>
        </ul>

        <SectionTitle>3. Order Tracking</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          Once your order is placed, you can track it live via our app/website.
        </p>
        <ul className="mb-4">
          <BulletPoint>Navigate to the <strong>My Orders</strong> section and click on the specific order to see real-time updates.</BulletPoint>
          <BulletPoint>You will receive live location tracking of your delivery partner once they are assigned.</BulletPoint>
        </ul>

        <SectionTitle>4. Delivery Areas</SectionTitle>
        <p className="text-gray-600 font-medium leading-relaxed mb-4">
          We are continuously expanding our delivery network. You can check if we deliver to your area by entering your pin code or using the "Use Current Location" feature on our platform.
        </p>
      </div>
    </div>
  );
};

export default ShippingInfoPage;